module.exports = __webpack_public_path__ + "img/schedule-service-bar-nissan.ce55a687.png";